import { Button, ErrorIcon } from '@native-instruments/webex-ni';
import { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import captureError from '@app/helpers/sentry';
import useRouterPush from '@app/hooks/useRouterPush';

import messages from '../Subscription.messages';

class SubscriptionErrorBoundary extends Component<{
  children?: React.ReactNode;
}> {
  state = { hasError: false };

  static getDerivedStateFromError = () => ({ hasError: true });

  componentDidCatch({ message, stack }: Error): void {
    captureError({
      stack,
      message,
      name: 'App Crashed',
      tags: [{ name: 'error_type', value: 'fatalError' }],
    });
  }

  render() {
    return this.state.hasError ? (
      <SubscriptionErrorComponent />
    ) : (
      this.props.children
    );
  }
}

export default SubscriptionErrorBoundary;

const SubscriptionErrorComponent = () => {
  const push = useRouterPush();

  return (
    <div
      className="ni-tailwind-namespace"
      style={{ flexGrow: 1 }}
      data-testid="subscription-generic-error"
    >
      <div
        className={
          'flex flex-col items-center justify-center container content-start grow mt-8'
        }
      >
        <ErrorIcon className="w-6 h-6 text-black" />

        <h1 className="webex-h3 mt-2">
          <FormattedMessage {...messages.genericErrorTitle} />
        </h1>

        <p className="mt-2 text-center">
          <FormattedMessage {...messages.genericErrorMessage} />
        </p>

        <div className="flex gap-3 mt-4">
          <Button variant="primary" onClick={() => push('/:language/account/')}>
            <FormattedMessage {...messages.genericErrorAccountButton} />
          </Button>
          <Button
            variant="primary"
            onClick={() =>
              push('/:language/products/subscription/360-subscription')
            }
          >
            <FormattedMessage {...messages.genericError360TrialButton} />
          </Button>
        </div>

        <p className="text-sm text-grey-60 mt-4 text-center">
          <FormattedMessage
            {...messages.genericErrorSupportMessage}
            values={{
              customerSupportLink: (
                <a
                  href="https://nativeinstruments.typeform.com/to/ksDb8o5s"
                  className="font-medium underline"
                >
                  <FormattedMessage {...messages.customerSupportLink} />
                </a>
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
};
